import { render, staticRenderFns } from "./photo_manage.vue?vue&type=template&id=7c5dbd0c&scoped=true&"
import script from "./photo_manage.vue?vue&type=script&lang=js&"
export * from "./photo_manage.vue?vue&type=script&lang=js&"
import style0 from "./photo_manage.vue?vue&type=style&index=0&id=7c5dbd0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5dbd0c",
  null
  
)

export default component.exports